module.exports = __webpack_public_path__ + "img/leftbicep-ectomorph-female.d2bcd150.svg";